import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  ThemeProvider,
} from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { MaterialReactTable } from "material-react-table";
import api from "../../../config/URL";
import CMSEnrollAndTermsPageAdd from "./CMSEnrollAndTermsPageAdd";
import CMSEnrollAndTermsPageEdit from "./CMSEnrollAndTermsPageEdit";
import GlobalDelete from "../../../components/common/GlobalDelete";
import {
  getColumnPreference,
  saveColumnPreference,
} from "../../../utility/mrtColumnPersistence";

const MODULE_KEY = "ENROLLANDTERMS";

function CMSEnrollAndTermsPage() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const handleMenuClose = () => setMenuAnchor(null);

  const storedScreens = JSON.parse(localStorage.getItem("screens") || "{}");

  const defaultColumnVisibility = {
    createdBy: false,
    createdAt: false,
    updatedBy: false,
    updatedAt: false,
  };

  const [columnVisibility, setColumnVisibility] = useState(() =>
    getColumnPreference(MODULE_KEY, defaultColumnVisibility),
  );
  /* ---------------- FETCH ALL ---------------- */
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/allDescriptionSave");
      setDatas(res.data || []);
    } catch (err) {
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ---------------- TABLE COLUMNS ---------------- */
  const columns = useMemo(
    () => [
      {
        accessorFn: (_, index) => index + 1,
        header: "S.NO",
        size: 50,
      },
      {
        accessorKey: "actions",
        header: "",
        size: 50,
        Cell: ({ row }) => (
          <IconButton
            onClick={(e) => {
              setMenuAnchor(e.currentTarget);
              setSelectedRow(row.original);
            }}
          >
            <MoreVertIcon />
          </IconButton>
        ),
      },
      {
        accessorKey: "description",
        header: "Title",
        size: 450,
      },
      { accessorKey: "createdBy", header: "Created By" },
      {
        accessorKey: "createdAt",
        header: "Created On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10),
      },
      {
        accessorKey: "updatedAt",
        header: "Updated On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10) || "",
      },
      {
        accessorKey: "updatedBy",
        header: "Updated By",
        Cell: ({ cell }) => cell.getValue() || "",
      },
    ],
    [],
  );

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: "#e6edf7",
            fontSize: "13px",
            textAlign: "center",
          },
        },
      },
    },
  });

  const PublishDescription = async () => {
    try {
      const response = await api.post(`/publishDescriptionSave`, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 201 || response.status === 200) {
        toast.success(response.data.message);
        fetchData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
    }
  };

  return (
    <div className="container-fluid p-2">
      <div className="card">
        <div className="d-flex justify-content-end p-2 gap-2">
          {storedScreens?.contactUsCreate && (
            <CMSEnrollAndTermsPageAdd onSuccess={fetchData} />
          )}
          <div>
            <button
              type="button"
              onClick={PublishDescription}
              className="btn btn-sm custom-outline-danger border ms-2"
            >
              Publish
            </button>
          </div>
        </div>

        {!loading && (
          <ThemeProvider theme={theme}>
            <MaterialReactTable
              columns={columns}
              data={datas}
              state={{ columnVisibility }}
              onColumnVisibilityChange={(updater) => {
                const newVisibility =
                  typeof updater === "function"
                    ? updater(columnVisibility)
                    : updater;

                setColumnVisibility(newVisibility);
                saveColumnPreference(MODULE_KEY, newVisibility);
              }}
              enableColumnActions={true}
              enableColumnFilters={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              initialState={{
                pagination: { pageSize: 50, pageIndex: 0 },
              }}
            />
          </ThemeProvider>
        )}

        {/* -------- ACTION MENU -------- */}
        <Menu
          id="action-menu"
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
          disableScrollLock
        >
          <MenuItem
            onClick={() => {
              setMenuAnchor(null);
              setEditOpen(true);
            }}
            className="text-start mb-0 menuitem-style"
          >
            Edit
          </MenuItem>

          <MenuItem>
            <GlobalDelete
              path={`/deleteDescriptionSave/${selectedRow?.id}`}
              onDeleteSuccess={fetchData}
              onOpen={handleMenuClose}
            />
          </MenuItem>
        </Menu>
      </div>

      {/* -------- EDIT MODAL -------- */}
      <CMSEnrollAndTermsPageEdit
        rowId={selectedRow?.id}
        open={editOpen}
        onClose={() => setEditOpen(false)}
        onSuccess={fetchData}
      />
    </div>
  );
}

export default CMSEnrollAndTermsPage;
